import '@edu-fe/weixin'
import assign from 'lodash.assign'
import api from '../lib/api'
import global from '../types/global.types'
import gift from '../types/gift.types'
import os from '@edu-fe/os'
import login from '@/utils/login'

const name = 'gift'

export default {
  name,
  namespaced: true,
  state: {
    ready: 0,
    isWeixin: false,
    type: 1,
    popup: false,
    registered: false,
    shareId: '',
    gift: {},
    result: {},
    popup_copy_href: 0,
    shareComponent: null // 分享组件
  },
  getters: {
    typeName (state) {
      return ['friend', 'workmate', 'theOne'][state.type - 1] || 'theOne'
    },
    typeNameCn (state) {
      return ['挚友', '同事', '恋人'][state.type - 1] || '恋人'
    },
    isSelf (state) {
      return state.isReceiveUser
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    'reset' (state, data) {
      state.gift = {}
      state.ready = 0
      state.type = 1
    },

    [gift.SET_GIFT] (state, data) {
      state.gift = data
      state.type = 1 // data.theme || 3
      state.ready = 1
    },

    [gift.OPEN_POPUP] (state) {
      state.popup = true
    },

    [gift.CLOSE_POPUP] (state) {
      state.popup = false
    },

    [gift.RECEIVE] (state, data) {
      state.result = data
    },

    [gift.COPY_HREF] (state, data) {
      state.popup_copy_href = ++state.popup_copy_href
    },

    [gift.SET_SHARE_COMPONENT]: (state, component) => (state.shareComponent = component),

    'removeShareComponent': state => state.shareComponent.close()
  },
  actions: {
    openPopup ({ commit }) {
      commit(gift.OPEN_POPUP)
    },

    closePopup ({ commit }) {
      commit(gift.CLOSE_POPUP)
    },

    give ({ state, commit }) {
      if (state.isWeixin) {
        const share = this._vm.$share()
        commit(gift.SET_SHARE_COMPONENT, share)
      } else {
        commit(gift.COPY_HREF)
      }
    },

    confirm ({ commit }) {
      commit(gift.CLOSE_POPUP)
    },

    begin ({ commit }) {
      commit(gift.CLOSE_POPUP)
    },

    async getSenderInfo ({ commit, state }) {
      // 重置状态
      commit('reset')

      try {
        const { code, data } = await api.gift.senderInfo(state.shareId)()
        if (code === -2) {
          login.login()
          location.reload()
        } else {
          commit(gift.SET_GIFT, data)
        }
      } catch (E) {
        commit(global.ERR, '获取赠送人信息失败！', { root: true })
      }
    },

    async receive ({ commit, state }) {
      try {
        this._vm.$loading.show()
        const res = await api.gift.receive(state.shareId)()
        this._vm.$loading.hide()

        const { result, reason } = res.data
        if (result !== 'success') {
          if (reason === 3) {
            commit(global.ERR, '你已拥有该课程，无法领取啦！', { root: true })
          } else if (reason === 2) {
            commit(global.ERR, '礼物已被领取', { root: true })
          }
        } else {
          commit(gift.RECEIVE, res.data)
          commit(global.ERR, '领取成功', { root: true })
        }
      } catch (E) {
        commit(global.ERR, '领取失败！', { root: true })
      }
    },

    // async checkLogin () {
    //   const wpsSid = await login.getWpsSid()
    //   if (!wpsSid) {
    //     login.login().then(() => { console.log('?'); location.reload() })
    //   }

    //   return wpsSid
    // },

    async init ({ dispatch, commit, rootState }) {
      const { shareId } = rootState.route.query
      commit('set', { shareId })
      commit('set', { isWeixin: os.type === 'weixin' })
      // weixin.init()
      await dispatch('getSenderInfo')
      return Promise.resolve()
    }
  }
}
